import React from 'react';
import './download-overlay.css';
var DownloadOverlay = function DownloadOverlay(_ref) {
    var url = _ref.url, label = _ref.label;
    return /*#__PURE__*/ React.createElement("div", {
        className: "download-overlay position-absolute-center d-flex align-items-center justify-content-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "align-self-center"
    }, /*#__PURE__*/ React.createElement("a", {
        href: url,
        className: "btn btn-outline-light text-center mx-auto",
        rel: "noreferrer",
        target: "_blank"
    }, label)));
};
export default DownloadOverlay;
